import type ItemResponseShape from "owa-service/lib/contract/ItemResponseShape";
import itemResponseShape from "owa-service/lib/factory/itemResponseShape";
import extendedPropertyUri from "owa-service/lib/factory/extendedPropertyUri";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import propertyUri from "owa-service/lib/factory/propertyUri";
import folderIdToName from "owa-session-store/lib/utils/folderIdToName";
import { getProactiveDraftExtendedPropertyUrisForRequest } from "owa-proactive-drafts-shared";
import type ExtendedPropertyUri from "owa-service/lib/contract/ExtendedPropertyUri";
import type PropertyUri from "owa-service/lib/contract/PropertyUri";

const COMMON_PROPERTY_SET_GUID = "00062008-0000-0000-C000-000000000046";

const FindItemShapeName: string = "MailListItem";

/**
 * Gets find item response shape.
 * @returns The ItemResponsShapee
 */
export function getFindItemResponseShape(folderId?: string): ItemResponseShape {
    const additionalProperties: (PropertyUri | ExtendedPropertyUri)[] = [];
    if (folderId && folderIdToName(folderId) == "scheduled") {
        additionalProperties.push(propertyUri({ FieldURI: "ReturnTime" }));
    }
    additionalProperties.push(...getProactiveDraftExtendedPropertyUrisForRequest());
    if (isGlobalFeatureEnabled("mon-copilot-daily-briefings")) {
        additionalProperties.push(extendedPropertyUri({
            PropertyName: "CopilotGeneratedContent",
            PropertySetId: COMMON_PROPERTY_SET_GUID,
            PropertyType: "String",
        }));
    }
    return itemResponseShape({
        BaseShape: "IdOnly",
        AdditionalProperties: additionalProperties.length > 0 ? additionalProperties : undefined,
    });
}

/**
 * Gets find item shape name
 * @returns the shape name
 */
export function getFindItemShape(): string {
    return FindItemShapeName;
}
